import theme from '../CustomTheme';

export const isSmartPhoneSize = () => {
  const maxWidth = theme.breakpoints.values.sm - 0.1;
  const result = matchMedia(`all and (max-width: ${maxWidth}px)`).matches;
  return result;
};
